module.exports = __webpack_public_path__ + "img/icons_10.15f6b519.png";